import { TranslationMap } from '@trimble-gcs/i18n-types';

export function downloadStatusTranslations() {
  return {
    title: {
      text: $localize`:@@downloadStatus.title:Download Status`,
      desc: 'Title for the downloads panel that shows the status of active and completed downloads.',
    },
    close: {
      tooltip: {
        text: $localize`:@@downloadStatus.close.tooltip:Close`,
        desc: 'Tooltip for the top right "X" button that closes the downloads panel.',
      },
    },
    overallProgress: {
      label: {
        text: $localize`:@@downloadStatus.overallProgress.label:Overall Progress`,
        desc: 'Label for the overall progress bar that shows the progress of all downloads combined.',
      },
      tooltip: {
        text: $localize`:@@downloadStatus.overallProgress.tooltip:Overall Progress: {percentageComplete}%`,
        desc: 'Tooltip for the overall progress bar that shows the progress of all downloads combined.',
      },
    },
    fileProgress: {
      tooltip: {
        text: $localize`:@@downloadStatus.fileProgress.tooltip:File Progress: {percentageComplete}%`,
        desc: 'Tooltip for the file progress bar that shows next to each file name.',
      },
    },
    noDownloads: {
      text: $localize`:@@downloadStatus.noDownloads:No downloads`,
      desc: 'Text shown when there are no downloads queued, in progress or completed.',
    },
    clear: {
      button: {
        text: $localize`:@@downloadStatus.clear.button:Clear`,
        desc: 'Text for the clear button. The button removes all completed downloads from the list.',
      },
      tooltip: {
        text: $localize`:@@downloadStatus.clear.tooltip:Clear Completed Downloads`,
        desc: 'Tooltip for the clear button. The button removes all completed downloads from the list.',
      },
    },
    cancel: {
      button: {
        text: $localize`:@@downloadStatus.cancel.button:Cancel`,
        desc: 'Text for the cancel button. The button will prompt to abort all downloads.',
      },
      tooltip: {
        text: $localize`:@@downloadStatus.cancel.tooltip:Cancel All Downloads`,
        desc: 'Tooltip for the cancel button. The button will prompt to abort all downloads.',
      },
    },
    confirmCancelDialog: {
      title: {
        text: $localize`:@@downloadStatus.confirmCancelDialog.title:Cancel Downloads`,
        desc: 'Title of the cancel confirmation dialog.',
      },
      message: {
        text: $localize`:@@downloadStatus.confirmCancelDialog.message:Are you sure you want to cancel all downloads?`,
        desc: 'Confirmation message shown when cancelling downloads.',
      },
      no: {
        text: $localize`:@@downloadStatus.confirmCancelDialog.no:No`,
        desc: 'Button text to abort cancelling of downloads.',
      },
      yes: {
        text: $localize`:@@downloadStatus.confirmCancelDialog.yes:Yes`,
        desc: 'Button text to confirm cancelling of downloads.',
      },
    },
  } satisfies TranslationMap;
}
